/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetShiftSchedulesRequest} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'
import {GetShiftSchedulesResponse} from '@cash-web/protos/squareup/timecards/scheduling/reporting_service.pb'


export const getShiftSchedules = (request: GetShiftSchedulesRequest, options?: CashRequestOptions) => post<GetShiftSchedulesRequest, GetShiftSchedulesResponse>("/proxy/services/squareup.timecards.scheduling.PublicSchedulingReportsService/GetShiftSchedules", request, {...options, rejectOnError: true })